/*
 *  全局定义信息
 *
 *  @author terrfly
 *  @site https://www.techpayx.vip
 *  @date 2021/5/8 07:18
 */

const errorPageRouteName = 'Error' //错误页面名称定义
// 点金计划支付成功页：用户经微信内全路径打开，首屏无 token；token 在 query 中由页面自行写入 config
const passGuardRouteList = [errorPageRouteName, 'CashierWxpayPaySuccess', 'CashierChannelsLaunch', "wxpay-test", 'CashierWxpayTest', 'CashierTransactionTest', 'Apps', 'MisCashier']

/** 定义支付方式 **/
const payWay = {
    WXPAY : {wayCode: "WX_JSAPI", routeName: "CashierWxpay", fixedRouteName: "CashierWxpayFixed"},
    ALIPAY : {wayCode: "ALI_JSAPI", routeName: "CashierAlipay", fixedRouteName: "CashierAlipayFixed"},
    YSFPAY : {wayCode: "YSF_JSAPI", routeName: "CashierYsfpay", fixedRouteName: "CashierYsfpayFixed"}
}

export default {
    errorPageRouteName: errorPageRouteName,
    passGuardRouteList: passGuardRouteList,
    urlTokenName: "techpayxToken", //URL传递的token名称
    payWay: payWay,
    cacheToken: ""
}
